import styled from 'styled-components';

export const Content = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 40px;
	align-items: start;
	margin-bottom: 40px;

	@media (max-width: 768px) {
		grid-template-columns: 1fr;
		gap: 32px; 
	}
`;

export const Image = styled.img`
	width: 100%;
	max-width: 100%; 
	height: auto;
	max-height: 400px;
	object-fit: cover;
	border-radius: 8px;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	margin-bottom: 24px;
`;

export const ColumnContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center; 
	align-self: start; 
`;

export const CalendarContainer = styled(ColumnContainer)``; // Inherit styles

export const ContactInfo = styled.p`
	font-size: clamp(1rem, 1.8vw, 1.1rem); 
	color: #4a4a4a;
	margin-top: 24px; 
	text-align: center; 
	font-style: italic;

	@media (max-width: 768px) {
		text-align: left; 
		margin-top: 16px;
	}
`;
